import {
    getHttpOptions,
    getClientOptions,
} from './settings.js';
import {
    applyRequestInterceptors,
    applyResponseInterceptors,
} from './interceptors.js';
import {sendRequest} from './request.js';
import {serialize} from './serializer.js';

const HTTP_GET = 'get';

/**
 * @param {HttpClientOptions} config
 * @returns {Promise<any>}
 */
export const zapi = async (config) => {
    const {method} = config;
    const clientOptions = getClientOptions();

    // When request results in a 50x error, make another attempt if "GET"
    // method was used. Why? Because Ivo told so.
    const retryOn50X = config.retryOn50X || method === HTTP_GET;

    let headers = new Headers({
        accept: 'application/json',
    });

    /** @type {HttpOptions} */
    let httpOptions = {
        ...getHttpOptions(),
        headers,
        method,
    };

    const request = await applyRequestInterceptors({
        path: clientOptions.basePath + config.path,
        payload: config.data,
        endpointID: config.endpointID,
        httpOptions,
    });

    // "httpOptions" could have been modified by an interceptor.
    httpOptions = request.httpOptions;
    headers = httpOptions.headers;

    if (clientOptions.stage) {
        headers.set('X-Zapi-Stage', clientOptions.stage);
    }

    if (request.payload) {
        if (method === HTTP_GET) {
            const searchParams = serialize(request.payload);

            if (searchParams.length) {
                request.path += '?' + searchParams;
            }
        } else if (config.useJSONData) {
            headers.set('content-type', 'application/json');
            httpOptions.body = JSON.stringify(request.payload);
        } else {
            headers.set('content-type', 'application/x-www-form-urlencoded');
            httpOptions.body = serialize(request.payload);
        }
    }

    const response = sendRequest(request, retryOn50X);

    return applyResponseInterceptors(response, request);
};

/**
 * @typedef {import('./interfaces').HttpOptions} HttpOptions
 * @typedef {import('./interfaces').HttpRequestInfo} HttpRequestInfo
 * @typedef {import('./interfaces').HttpClientOptions} HttpClientOptions
 */
